import styled from 'styled-components';

import { Page } from '../../../../services/bb-api/cms/page';

import { PageForm } from './page-form';
import { SectionForm } from './section-form';

export type CmsSidebarProps = {
	page: Page;
	setPage: (page: Page) => void;
	target: { id: string; layoutName: string; content: any; layout: string };
	setSelectedSectionId: (selectedSectionId: number | null) => void;
	onSectionChange: (changedValues: any, values: any) => void;
	onSectionUpdate: (sectionId: string, sectionUpdate: any) => void;
	onSectionDeletion: (sectionId: string) => void;

	className: string;
};

export const CmsSidebar = (props: CmsSidebarProps) => {
	return (
		<SidebarStyled className={props.className}>
			<PageForm visible={props?.target === null} page={props.page} setPage={props.setPage} />

			<SectionForm
				visible={props?.target !== null}
				selectedSection={props.target}
				onSectionChange={props.onSectionChange}
				onSectionDeletion={props.onSectionDeletion}
				setSelectedSectionId={props.setSelectedSectionId}
				onSectionUpdate={props.onSectionUpdate}
			/>
		</SidebarStyled>
	);
};

const SidebarStyled = styled.section`
	background-color: white;
	width: 360px;
	overflow-y: hidden;
	display: flex;
	height: 100%;
	flex-direction: column;

	label {
		font-size: 0.8rem;
		color: #999;
	}

	.ant-collapse .ant-collapse-header {
		padding-inline: 0;
		font-size: 0.8rem;
		color: #999;
		text-transform: uppercase;
	}

	form {
		display: flex;
		flex-direction: column;
		height: 100%;

		.ant-form-item-control-input-content {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 1ch;
		}
	}

	.ant-collapse {
		padding: 2ch;

		.ant-collapse-content-box {
			padding-top: 0 !important;
			padding-bottom: 0 !important;
		}
	}
`;
